import { ErrorState } from '@/components/common/ErrorState/ErrorState'
import { WidgetSpinner } from '@/components/common/Spinner/Spinner'
import { useBillingApi } from '@/hooks/useApi/useBillingApi/useBillingApi'
import { useTranslation } from 'react-i18next'

type BillNotesProps = {
    invoiceId: string
    billId: string
    usn: string
}

export const BillNotes: React.FC<BillNotesProps> = ({ invoiceId, billId }) => {
    const { useGetBillNotes } = useBillingApi()
    const query = useGetBillNotes(invoiceId, billId)
    const { data, isSuccess, isError } = query
    const { t } = useTranslation('translations')

    if (isSuccess) {
        return (
            <div className="space-y-4">
                {data.items.map((note) => (
                    <div
                        className="text-body-small rounded-lg border border-neutral-200 p-4"
                        key={note.billnoteId}
                    >
                        {note.note}
                    </div>
                ))}
            </div>
        )
    }

    if (isError) {
        return (
            <ErrorState
                className="h-full"
                description={t('common.error_state.description')}
                boxed={false}
            />
        )
    }

    return (
        <div className="flex h-full items-center justify-center">
            <WidgetSpinner />
        </div>
    )
}
